import React from "react";
import { Alert, Box, Container, Stack, Text, Title } from "@mantine/core";
import { InviteByEmailCard } from "./InviteProjectMember";
import { useAppSelector } from "../app/hooks";
import { ProjectInvitesGrid } from "./ProjectInvitesList";
import { ProjectMembersGrid } from "./ProjectMembersGrid";
import { selectHttpCurrentUser, selectIsSystemAdmin } from "../userSelectors";
import { FiInfo } from "react-icons/fi";

const noticeStyles = {
  root: { backgroundColor: "#fff3cd", border: "1px solid #d6a52b", color: "#664d03" },
  title: { color: "#664d03", fontWeight: 700 },
  message: { color: "#664d03" },
  icon: { color: "#856404" },
};

export const ProjectMembers: React.FC = () => {
  const user = useAppSelector(selectHttpCurrentUser);
  const isSystemAdmin = useAppSelector(selectIsSystemAdmin);

  if (!user) return <div>Laster tilgang…</div>;

  if (user.isExternal !== false) {
    return (
      <Container size="md" py="lg">
        <Alert icon={<FiInfo size={20} />} styles={noticeStyles} title="Ingen tilgang">
          Medlemssiden er kun tilgjengelig for interne brukere.
        </Alert>
      </Container>
    );
  }

  return (
    <Box style={{ height: "100%", width: "100%", minWidth: 0, overflowY: "auto" }}>
      <Container size="xl" py="xl" w="100%">
        <Stack gap="lg">
          <div>
            <Title order={2}>Eksterne prosjektmedlemmer</Title>
            <Text c="dimmed" size="sm" mt={4}>
              Oversikt over medlemmer og deres tilgang til prosjektet.
            </Text>
          </div>

          {!isSystemAdmin ? (
            <Alert
              icon={<FiInfo size={20} />}
              styles={noticeStyles}
              title="Begrenset tilgang"
              radius="md"
            >
              Kun systemadministratorer kan invitere eksterne brukere til prosjekter.
            </Alert>
          ) : (
            <>
              <Text size="sm" c="dimmed">
                Kun systemadministratorer kan invitere eksterne brukere til prosjekter.
              </Text>

              <InviteByEmailCard />
            </>
          )}

          <ProjectMembersGrid />

          {isSystemAdmin && <ProjectInvitesGrid />}
        </Stack>
      </Container>
    </Box>
  );
};
